import { Locale } from '@ps-smart-cp/ppfw-client';

const assetManagementClassNameConfig = {
  normalAsset: new Map([
    [Locale.ja, '通常資産'],
    [Locale.en, 'Normal Asset'],
  ]),
  smallSumAsset: new Map([
    [Locale.ja, '少額資産'],
    [Locale.en, 'Small Sum Asset'],
  ]),
  lumpSumDepreciableAsset: new Map([
    [Locale.ja, '一括償却資産'],
    [Locale.en, 'Lump Sum Depreciable Asset'],
  ]),
  unaccountedAsset: new Map([
    [Locale.ja, '簿外資産'],
    [Locale.en, 'Unaccounted Asset'],
  ]),
  researchAndDevelopmentExpense: new Map([
    [Locale.ja, '研究開発費'],
    [Locale.en, 'Research and Development Expense'],
  ]),
  ownershipRightsTransferLease: new Map([
    [Locale.ja, '所有権移転リース'],
    [Locale.en, 'Ownership Rights Transfer Lease'],
  ]),
  ownershipRightsNonTransferLease: new Map([
    [Locale.ja, '所有権移転外リース'],
    [Locale.en, 'Ownership Rights Non Transfer Lease'],
  ]),
} satisfies Record<string, Map<Locale, string>>;

export { assetManagementClassNameConfig };
